
if(document.querySelector('.input-select')){
    const selects = document.querySelectorAll('.input-select')
    selects.forEach(sel => {
        
        const result = sel.querySelector('.result')
        const selSelector = sel.querySelector('select')
        // console.log(selSelector.value)
        selSelector.addEventListener('change', ()=>{
            result.value = selSelector.value
            
        })
    })
}